import React, { createContext, useContext } from 'react';

import { loadStripe } from '@stripe/stripe-js';

const StripeContext = createContext();

let stripePromise = null;
const getStripePromise = () => {
  if (stripePromise) return stripePromise;
  if (typeof window !== 'undefined' && window.location?.protocol !== 'https:') {
    return null;
  }
  stripePromise = loadStripe(import.meta.env?.VITE_STRIPE_PUBLISHABLE_KEY);
  return stripePromise;
};

export const StripeProvider = ({ children }) => {
  const stripePromiseValue = getStripePromise();
  const stripeOptions = {
    appearance: {
      theme: 'stripe',
      variables: {
        colorPrimary: 'hsl(var(--color-primary))',
        colorBackground: 'hsl(var(--color-card))',
        colorText: 'hsl(var(--color-foreground))',
        colorDanger: 'hsl(var(--color-error))',
        fontFamily: 'Inter, system-ui, sans-serif',
        spacingUnit: '4px',
        borderRadius: '8px',
      }
    }
  };

  return (
    <StripeContext.Provider value={{ stripePromise: stripePromiseValue, stripeOptions }}>
      {children}
    </StripeContext.Provider>
  );
};

export const useStripeContext = () => {
  const context = useContext(StripeContext);
  if (!context) {
    throw new Error('useStripeContext must be used within a StripeProvider');
  }
  return context;
};

export default StripeContext;